import { MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';
import { FC } from 'react';
import type { SignOutReason } from '../services/authHelper';

const reasonMessages: Record<SignOutReason, string> = {
  authFailed:
    'We could not verify your access. You have been signed out. Please sign in again.',
  sessionExpired: 'Your session has expired. Please sign in again.',
};

const readSignOutReason = (): SignOutReason | null => {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get('reason');
  if (reason && reason in reasonMessages) return reason as SignOutReason;
  return null;
};

export const SignInScreen: FC<{ onSignIn: () => void }> = ({ onSignIn }) => {
  const reason = readSignOutReason();
  return (
    <div className="App">
      {reason && (
        <MessageBar messageBarType={MessageBarType.warning}>
          {reasonMessages[reason]}
        </MessageBar>
      )}
      <p>You are not signed in! Please sign in.</p>
      <PrimaryButton onClick={onSignIn}>Organization Sign In</PrimaryButton>
    </div>
  );
};

export const CheckingAccessScreen: FC = () => (
  <div className="App">
    <p>Checking access...</p>
  </div>
);

export const NoAccessScreen: FC<{ onSignOut: () => void }> = ({
  onSignOut,
}) => (
  <div className="App">
    <h3>You don't have access to this portal</h3>
    <p>
      Your account is signed in but has not been granted access. Please contact
      your administrator, or sign out and try a different account.
    </p>
    <PrimaryButton onClick={onSignOut}>Sign out</PrimaryButton>
  </div>
);
